// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import { AnalysisStatusIdEnum } from 'config/enums'
import getAnalysisStatusColor from './getAnalysisStatusColor'

// takes the analysisStatusId and returns a Font-Awesome
// icon class which is associated with that status id.

const getAnalysisStatusIcon = analysisStatusId => {
  let iconClasses

  switch (analysisStatusId) {
    case null :
      iconClasses = 'fa-circle-o'
      break

    case AnalysisStatusIdEnum.WAITING :
      iconClasses = 'fa-clock-o'
      break

    case AnalysisStatusIdEnum.RUNNING :
      iconClasses = 'fa-spinner fa-spin'
      break

    case AnalysisStatusIdEnum.COMPLETED :
      iconClasses = 'fa-check'
      break

    case AnalysisStatusIdEnum.FAILED :
      iconClasses = 'fa-times'
      break

    case AnalysisStatusIdEnum.STALE :
      iconClasses = 'fa-check'
      break

    default :
      // if you are here, you must be lost.
      // here's a map to help guide you.
      console.warn('Warning in getAnalysisStatusIcon: unmapped analysisStatusId of ' + analysisStatusId + ' was called.')
      iconClasses = 'fa-map-o'
      break
  }

  return `fa ${iconClasses} ${getAnalysisStatusColor(analysisStatusId)}`
}

export default getAnalysisStatusIcon
